import React from 'react';
import { FieldArray, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/crud';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

class GroupField extends React.Component {
  constructor(props, context) {
    super(props);
    const { children, addFieldCriteriaAction, name } = props;
    const { entity, isEdit } = context;

    if (isEdit) {
      let fieldCriteria = [];
      if (children.length) {
        fieldCriteria = children.reduce((result, current) => {
          const { props: { name: fieldName, lookupEntity } } = current;
          if (lookupEntity) {
            return result.concat(['id', 'key', 'description'].map((column) => `${name}.${fieldName}.${column}`));
          }
          result.push(`${name}.${fieldName}`);
          return result;
        }, []);
      } else {
        const { props: { name: fieldName } } = children;
        fieldCriteria.push(`${name}.${fieldName}`);
      }
      addFieldCriteriaAction({ entity, fieldCriteria });
    }
  }

  componentDidMount() {
    const { name, defaultValue, initializeAction } = this.props;
    const { entity, isGrid, isEdit } = this.context;
    if (!isGrid && !isEdit) {
      initializeAction(entity, { [name]: defaultValue }, { keepValues: true });
    }
  }

  renderButton = ({ onClick, label }) => (
    <div className="groupFieldButton" onClick={onClick} onKeyPress={onClick} role="button" tabIndex={0}>{label}</div>
  );

  renderRows = ({ fields: rows, children, meta: { error, submitFailed } }) => {
    const { requiredOnce, showOnlyOneItem, onRemoveItemAction } = this.props;
    return (
      <div className="groupField">
        {rows.length === 0 ? (
          <div className="groupFieldNoItems">
            <div className="groupFieldNoItemsMessage">{Monet.I18n.getResourcesByKey('general.groupField.noItems')}</div>
            {this.renderButton({
              onClick: () => {
                rows.push({});
              },
              label: '+'
            })}
          </div>
        ) : null}
        {rows.map((row, index) => {
          const showError = error?.has(index) && submitFailed;
          const childrenWithProps = React.Children.map(
            children, (child) => React.cloneElement(child, { name: `${row}.${child.props.name}`, key: `${row}.${child.props.name || child.props.key}` })
          );
          return (
            <div key={index.toString()}>
              <div className={`groupFieldItem ${showError ? 'error' : ''}`}>
                {childrenWithProps}
                {(requiredOnce && rows.length > 1) || (!requiredOnce && rows.length > 0)
                  ? this.renderButton({
                    onClick: () => {
                      if (onRemoveItemAction) {
                        onRemoveItemAction(rows, index);
                      } else {
                        rows.remove(index);
                      }
                    },
                    label: '-'
                  })
                  : null}
                {
                (!showOnlyOneItem && index === rows.length - 1)
                  ? this.renderButton({
                    onClick: () => rows.push({}), label: '+'
                  })
                  : null
                }
              </div>
              {showError && <div className="fieldMessage error"><span>{error.get(index)}</span></div>}
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { isGrid } = this.context;
    return !isGrid ? (
      <FieldArray component={this.renderRows} {...this.props} />
    ) : null;
  }
}

GroupField.contextType = CrudContext;

GroupField.propTypes = {
  defaultValue: PropTypes.array,
  name: PropTypes.string.isRequired,
  initializeAction: PropTypes.func.isRequired,
  onRemoveItemAction: PropTypes.func,
  children: PropTypes.node.isRequired,
  addFieldCriteriaAction: PropTypes.func.isRequired,
  requiredOnce: PropTypes.bool,
  showOnlyOneItem: PropTypes.bool
};

GroupField.defaultProps = {
  defaultValue: [],
  requiredOnce: false,
  showOnlyOneItem: false,
  onRemoveItemAction: undefined
};

const mapDispatchToProps = {
  initializeAction: initialize,
  addFieldCriteriaAction: actionCreators.addFieldCriteria
};

export default connect(null, mapDispatchToProps)(GroupField);
